interface AppConfig {
  environment: string;
  distEnv: string;
  apiEndpoint: string;
  shiComBaseUrl: string;
  customerSuccessUi: string;
  filepondSchemas: string;
  partnerLogos: string;
  logos: string;
  auth0: {
    domain: string;
    clientId: string;
    callbackUrl: string;
    logoutUrl: string;
    audience: string;
    logoutDirect: string;
  };
  telemetry: {
    insightsEnabled: string;
    insightsInstrumentationKey: string;
  };
  userflow: {
    enabled: string;
    token: string;
  };
}

const APP_CONFIG: AppConfig = {
  environment: import.meta.env.MODE,
  distEnv: import.meta.env.DIST_ENV,
  apiEndpoint: import.meta.env.API_ENDPOINT,
  shiComBaseUrl: import.meta.env.SHICOM_BASE_URL,
  customerSuccessUi: import.meta.env.CUSTOMER_SUCCESS_UI,
  filepondSchemas: import.meta.env.FILEPOND_SCHEMAS,
  partnerLogos: import.meta.env.PARTNER_LOGOS,
  logos: import.meta.env.LOGOS,
  auth0: {
    domain: import.meta.env.AUTH0_DOMAIN,
    clientId: import.meta.env.AUTH0_CLIENTID,
    callbackUrl: import.meta.env.AUTH0_CALLBACK_URL,
    logoutUrl: import.meta.env.AUTH0_LOGOUT_URL,
    audience: import.meta.env.AUTH0_AUDIENCE,
    logoutDirect: import.meta.env.AUTH0_LOGOUT_DIRECT,
  },
  telemetry: {
    insightsEnabled: import.meta.env.INSIGHTS_TELEMETRY_ENABLED,
    insightsInstrumentationKey: import.meta.env.INSIGHTS_INSTRUMENTATION_KEY,
  },
  userflow: {
    enabled: import.meta.env.USERFLOW_ENABLED,
    token: import.meta.env.USERFLOW_TOKEN,
  },
};

const redact = (value: string | undefined): string | undefined =>
  value ? "[redacted]" : value;

export const logRuntimeConfig = () => {
  if (!import.meta.env.DEV) {
    return;
  }

  const redactedConfig = {
    ...APP_CONFIG,
    auth0: {
      ...APP_CONFIG.auth0,
      clientId: redact(APP_CONFIG.auth0.clientId),
      audience: redact(APP_CONFIG.auth0.audience),
    },
    telemetry: {
      ...APP_CONFIG.telemetry,
      insightsInstrumentationKey: redact(
        APP_CONFIG.telemetry.insightsInstrumentationKey,
      ),
    },
    userflow: {
      ...APP_CONFIG.userflow,
      token: redact(APP_CONFIG.userflow.token),
    },
  };

  console.groupCollapsed("[runtime-config] customer-experience");
  console.table(redactedConfig);
  console.groupEnd();
};

